<div class="px-4">
    <div class="flex-align-center flex justify-between">
        <h2
            class="orb-app-light-dark:font-semibold flex-align-center flex gap-2 text-xs font-bold uppercase text-grey-dark dark:filter-yellow"
            [class.normal-case]="env.REMOVE_UPPERCASE">
            {{ 'RECENTS' | translate }}
        </h2>
        <ion-button
            class="var-app-light:text-primary orb-app-light-dark:text-xm my-0 -mr-2 h-12 text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
            (click)="clearRecentSearch()"
            fill="clear">
            <ion-label class="text-xs font-semibold normal-case">
                {{ 'RECENTS_CLEAR' | translate }}
            </ion-label>
        </ion-button>
    </div>
    <ng-container *ngFor="let journey of searchRecentlyJourneys$ | async">
        <rwidget-journey-planner-location-mark
            class="block border-t border-solid border-[#0000001a] dark:border-contrast-yellow"
            [isShowRemoveIcon]="false"
            [location]="{
                origin: journey.origin?.useCurrentLocation ? ('CURRENT_LOCATION' | translate) : journey.origin?.name,
                destination: journey.destination?.useCurrentLocation
                    ? ('CURRENT_LOCATION' | translate)
                    : journey.destination?.name
            }"
            [municipalityName]="{
                origin: journey.origin?.municipalityName,
                destination: journey.destination?.municipalityName
            }"
            (clickOnLocation)="onJourneyClick(journey)"></rwidget-journey-planner-location-mark>
    </ng-container>
</div>
